import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import style from './index.scss';

/**
 * The unsaved-changes indicator and the two actions, top-right of the page.
 *
 * §17: nothing takes effect until Save is pressed, and the indicator clears after
 * a successful save. So the pill is not decoration — it is the only thing telling
 * an admin that what they are looking at is not what the Spatial View will use.
 *
 * NO RESET BUTTON (removed 2026-09-07, on request). It used to sit left of Save,
 * scoped to the SELECTED TYPE.
 *
 * WORTH KNOWING, because the story disagrees: the acceptance criteria name a
 * reset — "Reset this type ... only that event type is reset" — and §1 lists a
 * page-level one. Both are now unimplemented. Discarding edits means leaving the
 * type and coming back, which refetches from the server; the unsaved-changes
 * pill is the only warning that anything would be lost. Raised rather than
 * silently dropped.
 */
const SaveBar = ({ dirty, saving, onSave }) => (
  <div className={style.saveBar}>
    {dirty ? <span className={style.unsavedPill}>Unsaved changes</span> : null}

    <Button
      type="primary"
      className={style.primaryButton}
      loading={saving}
      disabled={!dirty}
      onClick={onSave}
    >
      Save changes
    </Button>
  </div>
);

SaveBar.propTypes = {
  dirty: PropTypes.bool,
  saving: PropTypes.bool,
  onSave: PropTypes.func.isRequired
};

SaveBar.defaultProps = { dirty: false, saving: false };

export default SaveBar;
